<div class="pale-grey-wrapper courses">
  <ng-container *ngIf="noCourses; else coursesView">
    <ng-content select="[noCourses]"></ng-content>
  </ng-container>

  <ng-template #coursesView>
    <lms-toolbar [options]="toolbarConfig">
      <div left>
        <gl-button
          color-secondary
          [text]="'actions.filter' | translate"
          [active]="showFilters"
          icon-left="glicon-filter"
          (onClick)="showFilterPanel($event['detail']['returnValue'], null)"
        ></gl-button>
      </div>
      <div class="courses-view">
        <span
          (click)="setViewMode(viewModes.cards)"
          class="glicon-f-mosaic"
          [ngClass]="{ active: viewMode === viewModes.cards }"
        ></span>
        <span
          (click)="setViewMode(viewModes.list)"
          class="glicon-burger"
          [ngClass]="{ active: viewMode === viewModes.list }"
        ></span>
      </div>
      <ng-content select="[actions]"></ng-content>
    </lms-toolbar>

    <!-- cards filters -->
    <div
      #filtersPanel
      class="filters__container"
      [ngClass]="{ 'display-none': !showFilters }"
      tabindex="-1"
      (focusout)="showFilterPanel(false, $event)"
    >
      <div class="filters__form">
        <lms-dynamic-form
          #filtersform
          [questions]="filterQuestions"
          [action]="formAction"
          (submit)="filter($event)"
          [options]="{ disableCard: true, submitLabel: 'actions.filter', enableFullWidthForm: true }"
        >
          <gl-button
            color-secondary
            [attr.disabled]="filtersform.form.pristine ? true : null"
            [text]="'actions.clean' | translate"
            form-actions-before
            (onClick)="resetFilters()"
          ></gl-button>
        </lms-dynamic-form>
      </div>
    </div>

    <div *ngIf="selectable && selectedCourses.size > 0" class="padding-top-16">
      <div class="lms-toolbar__secondary" [ngClass]="{ hidden: selectedCourses.size === 0 }" tools-actions>
        <div class="list-counter">
          <span>
            {{ selectedCourses.size }}
            <span *ngIf="dataSource?.docs[0]?.type === 'itinerary'">{{
              (selectedCourses.size === 1 ? 'itinerary.selectedSingle' : 'itinerary.selected') | translate
            }}</span>
            <span *ngIf="dataSource?.docs[0]?.type !== 'itinerary'">{{
              (selectedCourses.size === 1 ? 'courses.selectedSingle' : 'courses.selected') | translate
            }}</span>
          </span>

          <a
            (click)="setSelectAll(true)"
            *ngIf="!selectAll"
            title="{{ 'courses.selectedAllCourses' | translate : { total: dataSource.total } }}"
            >{{ 'courses.selectedAllCourses' | translate : { total: dataSource.total } }}
          </a>
        </div>
        <div class="actions">
          <ng-container>
            <lms-button-actions
              id="courses_list_bulk_actions"
              class="margin-half-right margin-half-left"
              [items]="bulkActions"
              (change)="selectAction($event)"
            ></lms-button-actions>
          </ng-container>
          <div class="border-left padding-left margin-left-8">
            <gl-button
              color-secondary
              small
              [text]="'actions.cancelSelection' | translate"
              (onClick)="setSelectAll(false)"
            >
            </gl-button>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="viewMode === 'cards'; else listView">
      <!-- cards view -->
      <div class="courses-cards-container">
        <div class="courses-cards">
          <lms-course-card
            [userRole]="user.role"
            *ngFor="let course of dataSource.docs"
            [course]="course"
            [selectable]="selectable"
            [selected]="selectedCourses.has(course.id)"
            [defaultAccessMode]="options.defaultAccessMode"
            (courseSelected)="onCourseSelectionChanged($event)"
            (courseEvent)="emitCourseEvent($event)"
          ></lms-course-card>
        </div>
        <div class="not-result-search" *ngIf="dataSource.docs.length === 0">
          <div class="not-result-search__icon"></div>
          <div class="not-result-search__message">
            {{ 'actions.noResultTable' | translate }}
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #listView>
      <!-- table view  -->
      <div class="gl-table__container" [ngClass]="{ selected: selectedCourses.size > 0 }">
        <gl-table
          #coursesTable
          [id]="coursesTableListId"
          [dataSource]="dataSource"
          data-testid="classesTable"
          [placeholder]="'actions.noResultTable' | translate"
          [attr.selectable]="selectable ? true : null"
          (onSelectionChanged)="onSelectionChanged($event.detail)"
          (onRowSelectionChanged)="onCourseSelectionChanged($event.detail)"
          (onFiltersChanged)="onFiltersChanged()"
          (onDatasourceUpdate)="onDatasourceUpdate()"
        >
        </gl-table>
      </div>
    </ng-template>
  </ng-template>
</div>
